import { AudioFilled, DeleteOutlined, XFilled } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import { formatSeconds } from './utils'
import { lang } from './lang'
import s from './s.module.css'
import LockIcon from './lock.svg?react'
import AudioPlayer from '@/components/AudioPlayer'

type Props = {
  onStart: () => void
  onStop: () => void
  isRecording: boolean
  onDelete?: () => void
  maxDuration?: number
  recordingTime?: number
  recordingLength?: number
  isRecorded: boolean
  isBlocked?: boolean
  audioSrc?: string
}

export default function Controls({
  isRecording,
  isRecorded,
  onStop,
  onStart,
  maxDuration,
  recordingLength,
  recordingTime,
  onDelete,
  isBlocked,
  audioSrc,
}: Props) {
  if (isBlocked) {
    return (
      <Flex gap={16}>
        <Flex align="center" justify="center" className={s.blockedIcon}>
          <Flex align="center" justify="center" className={s.badge}>
            <LockIcon style={{ color: 'var(--grey-100)', width: '12px' }} />
          </Flex>
          <AudioFilled size={20} />
        </Flex>
        <Text type="primary" fontSize={14} fontType="body">
          <FormattedMessage {...lang.blocked} />
        </Text>
      </Flex>
    )
  }
  if (!isRecording && !isRecorded) {
    return (
      <>
        <Button onClick={onStart} type="link" icon={<AudioFilled size={20} />} style={{ padding: 0 }}>
          <FormattedMessage {...lang.startRecording} />
        </Button>
        {maxDuration ? (
          <Text type="tertiary" fontType="body" fontSize={14}>
            <FormattedMessage {...lang.maxDuration} values={{ valueInSeconds: maxDuration }} />
          </Text>
        ) : null}
      </>
    )
  }

  if (isRecording) {
    return (
      <>
        <Button onClick={onStop} type="link" icon={<XFilled size={20} />} style={{ padding: 0 }}>
          <FormattedMessage {...lang.stopRecording} />
        </Button>
        <Flex align="center" gap={4}>
          <span className={s.recordingDot} />
          <Text type="primary" fontType="body" fontSize={14}>
            {formatSeconds(recordingTime)} / {formatSeconds(maxDuration)}
          </Text>
        </Flex>
      </>
    )
  }

  if (isRecorded && audioSrc) {
    return (
      <>
        <Flex gap={8} align="center">
          <AudioPlayer audioSrc={audioSrc} buttonType="flat" />
          <Text type="primary" fontType="body" fontSize={14}>
            {formatSeconds(recordingLength)} / {formatSeconds(maxDuration)}
          </Text>
        </Flex>
        <Button onClick={onDelete} type="link" danger icon={<DeleteOutlined size={20} />}>
          <FormattedMessage {...lang.delete} />
        </Button>
      </>
    )
  }
}
